import { useEffect } from "react";

export default function Toast({ active, title, text, setToastshow }:
    {
        active: boolean,
        title: string | undefined,
        text: string | undefined,
        setToastshow: React.Dispatch<React.SetStateAction<boolean>>
    }) {

    useEffect(() => {
        setTimeout(() => {
            setToastshow(false);
        }, 6000);
    }, [active]);

    return (
        <div dir="rtl" className={
            `absolute bottom-[13vh] left-0 w-[150px] h-[100px] min-w-fit min-h-fit bg-[#333] border-r-4 border-primary z-50
            flex flex-col justify-center py-2 px-4
            transform transition-transform duration-300
            ${active ? "translate-x-0" : "-translate-x-full"}`}
        >
            <h5 className="text-primary text-lg my-2 transition">{title}</h5>
            <p className="text-primary/70 my-2 transition">{text}</p>
        </div>
    );
}